import { Pipe, PipeTransform } from '@angular/core';
import { CashFlowPaymentMethod } from '../../../../data/src/lib/entities/treasury.model';

/**
 * Translation keys (not plain strings like sibling `...LabelPipe`s) because
 * PaymentMethod surfaces on the operator-facing movements grid and needs
 * to follow the active locale. Consumers chain with the `translate` pipe:
 *
 *   {{ entry.PaymentMethod | cashFlowPaymentMethodLabel | translate }}
 */
const LABEL_KEYS: Record<CashFlowPaymentMethod, string> = {
  [CashFlowPaymentMethod.Cash]: 'TREASURY.CASH.PAYMENT_METHOD.CASH',
  [CashFlowPaymentMethod.Card]: 'TREASURY.CASH.PAYMENT_METHOD.CARD',
  [CashFlowPaymentMethod.Pix]: 'TREASURY.CASH.PAYMENT_METHOD.PIX',
  [CashFlowPaymentMethod.BankSlip]: 'TREASURY.CASH.PAYMENT_METHOD.BANK_SLIP',
  [CashFlowPaymentMethod.Check]: 'TREASURY.CASH.PAYMENT_METHOD.CHECK',
};

@Pipe({ name: 'cashFlowPaymentMethodLabel', standalone: true, pure: true })
export class CashFlowPaymentMethodLabelPipe implements PipeTransform {
  transform(value: CashFlowPaymentMethod | null | undefined): string {
    if (value === null || value === undefined) {
      return '';
    }
    return LABEL_KEYS[value] ?? '';
  }
}
